import { api, fmtMonth, gbp } from "@/admin/api";
import { Card, ErrorMsg, Loading, Stat, useAsync } from "@/admin/ui";

export default function Revenue() {
  const { data, error, loading } = useAsync(() => api("/admin/revenue"), []);
  if (loading) return <Loading />;
  if (error) return <ErrorMsg error={error} />;
  const max = Math.max(1, ...data.series.map((s) => s.total));
  return (
    <div data-testid="revenue-page" className="space-y-6">
      <h1 className="text-2xl font-bold text-navy md:text-3xl">Revenue</h1>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat testId="rev-this-month" label="This month" value={gbp(data.this_month)} />
        <Stat testId="rev-last-month" label="Last month" value={gbp(data.last_month)} />
        <Stat testId="rev-ytd" label="Year to date" value={gbp(data.year_to_date)} />
        <Stat testId="rev-lifetime" label="Lifetime revenue" value={gbp(data.lifetime)} hint="Finished jobs" />
      </div>
      <Card>
        <h2 className="mb-4 text-lg font-bold text-navy">Money in per month</h2>
        <div data-testid="revenue-chart" className="flex h-56 items-end gap-1.5 sm:gap-3">
          {data.series.map((s) => (
            <div key={s.month} data-testid={`bar-${s.month}`} className="flex flex-1 flex-col items-center justify-end gap-1" title={`${fmtMonth(s.month)}: ${gbp(s.total)}`}>
              <span className="hidden text-[11px] font-semibold text-navy sm:block">{s.total ? gbp(s.total) : ""}</span>
              <div className="w-full rounded-t-md bg-brand transition-[height] duration-500" style={{ height: `${Math.max(s.total ? 4 : 1, (s.total / max) * 170)}px` }} />
              <span className="text-[10px] text-body sm:text-xs">{fmtMonth(s.month)}</span>
            </div>
          ))}
        </div>
        {data.lifetime === 0 && <p data-testid="revenue-empty" className="mt-4 text-center text-sm text-body">No finished jobs yet. Give a job a value and a finish date and it will appear here.</p>}
      </Card>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <Stat testId="rev-total-won" label="Total won" value={gbp(data.total_won)} hint="All won jobs" />
        <Stat testId="rev-won-unfinished" label="Won, not yet finished" value={gbp(data.won_not_finished)} />
        <Stat testId="rev-quoted" label="Quoted, not yet won" value={gbp(data.quoted_not_won)} />
      </div>
    </div>
  );
}
